import { Component, OnInit } from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { InProductsService } from '../../services/inventory/in-products.service'
import { DataService } from '../../services/data.service'
export interface StockHistoryModel {
  title: string;
  data: any;
}
@Component({
  selector: 'app-stocklist-popup',
  templateUrl: './stocklist-popup.component.html',
  styleUrls: ['./stocklist-popup.component.css']
})
export class StockListPopupComponent extends DialogComponent<StockHistoryModel, boolean> implements StockHistoryModel, OnInit {
  title: string;
  data: any = {};
  model = new StockList_Master();
  result: any = { result: false, RtnItem: {} };
  loading: boolean = false;

  constructor(dialogService: DialogService, private ds: DataService, private ps: InProductsService) { super(dialogService); }

  ngOnInit() {
    this.model = new StockList_Master();

    if (this.data != "") {
      this.getstockList();
    }
  }

  getstockList() {
    var data = {
      Barcode: this.data,
      LocationId: this.ds.Settings.LocationId,
      CompanyId: this.ds.Settings.CompanyId
    }
    this.loading = true;
    this.ps.Get_LocationStockListByBarcode(data).subscribe(res => {
      if (res.Success) {
        this.model = res.data;
        this.loading = false;
      }
      else {
        alert(res.error.UsrMsg);
        this.loading = false;
      }
    })

  }

  ok() {
    this.close();
  }

}

class StockList_Master {
  ItemId: number = 0;
  Barcode: string = "";
  ItemName: string = "";
  Unit: string = "";
  Contain: number = 0;
  TaxRate: number = 0;
  CurrentStock: number = 0;
  LocationStockList: BOStockHistory_Master[] = [];
}

class BOStockHistory_Master {
  Location: string = "";
  Qty: number = 0;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/stocklist-popup/stocklist-popup.component.ts